import { computed } from "vue";
/**
 * Parses an EntityLayoutResponse and provides a sorted, type-narrowed block list.
 *
 * Type guards:
 *   block.kind === 'hardcoded' → HardcodedBlockDefinition
 *   block.kind === 'generic'   → GenericBlockDefinition
 */
export function useEntityLayout(response) {
    const entityId = computed(() => response.value?.id ?? "");
    const blocks = computed(() => {
        const raw = response.value?.layout.blocks ?? [];
        return [...raw].sort((a, b) => a.order - b.order);
    });
    function getBlock(id) {
        return blocks.value.find((b) => b.id === id);
    }
    function getHardcodedBlock(id) {
        const block = getBlock(id);
        return block?.kind === "hardcoded" ? block : undefined;
    }
    function getGenericBlock(id) {
        const block = getBlock(id);
        return block?.kind === "generic" ? block : undefined;
    }
    return {
        entityId,
        blocks,
        getBlock,
        getHardcodedBlock,
        getGenericBlock,
    };
}
